import { render, staticRenderFns } from "./AssociatedInstances.vue?vue&type=template&id=2dbd8db6"
import script from "./AssociatedInstances.vue?vue&type=script&lang=js"
export * from "./AssociatedInstances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports